import React, { useContext } from "react";
import { LanguageNameSpaces, TradeData } from "@shared/types";
import { SocketPnlContext } from "@shared/features/dashboard/SocketPnl.context";
import { useTotalPnl } from "@shared/features/socket/hooks";
import MobileStatisticItem from "features/dashboard/MobileDashboard/MobileStatisticItem";
import { useBottomNavigator } from "utils/hooks/misc";
import StatisticItem from "features/dashboard/Statistics/StatisticItem";
import { BalanceScaleIcon } from "common/Icons/Icons.tsx";
import { useTheme } from "styled-components";
import { hexToRGB } from "@shared/utils/misc.ts";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

interface PnlStatisticItemProps {
  openTradesData: TradeData[];
}

const PnlStatisticItem = ({ openTradesData }: PnlStatisticItemProps) => {
  const theme = useTheme();
  const { socketPnlValue } = useContext(SocketPnlContext)!;
  const totalPnl = useTotalPnl(openTradesData, socketPnlValue);
  const { baseShouldDisplay: isBottomNavigator } = useBottomNavigator();
  const { t } = useTypedTranslation(LanguageNameSpaces.DASHBOARD);

  if (isBottomNavigator) {
    return (
      <MobileStatisticItem
        title={t("statistics.open_trades_pnl_mobile")}
        value={totalPnl}
      />
    );
  }

  return (
    <StatisticItem
      title={t("statistics.open_trades_pnl")}
      icon={
        <BalanceScaleIcon
          style={{ fill: hexToRGB(theme.colors.primaryBlue, 0.8) }}
        />
      }
      value={totalPnl}
    />
  );
};

export default PnlStatisticItem;
